exports.components = {
  "component---src-pages-abonado-[id]-tsx": () => import("./../../../src/pages/abonado/[id].tsx" /* webpackChunkName: "component---src-pages-abonado-[id]-tsx" */),
  "component---src-pages-ejercicios-tsx": () => import("./../../../src/pages/ejercicios.tsx" /* webpackChunkName: "component---src-pages-ejercicios-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-preview-[id]-tsx": () => import("./../../../src/pages/preview/[id].tsx" /* webpackChunkName: "component---src-pages-preview-[id]-tsx" */)
}

